import getLocale from './locale';

export default {
  getLocale,
};
